import { useDispatch, useSelector } from 'react-redux';
import ImportMenuView from 'components/ImportMenu/ImportMenuView';
import {
  importMenuFromJson,
  emptyPosMenu,
  exportPosMenu,
} from '../../../redux/actions/posMenu';

const BREAK_GLASS_PAGE = 'pos-menu-import';
const EMPTY_ACTION_SUMMARY = 'Empty POS menu for this business';

const PosMenuImport = () => {
  const dispatch = useDispatch();
  const currentBusiness = useSelector(
    ({ business }) => business.currentBusiness
  );
  const businessUuid = currentBusiness?.uuid;

  return (
    <ImportMenuView
      businessUuid={businessUuid}
      breakGlassPage={BREAK_GLASS_PAGE}
      breakGlassEventType="pos-menu-import-action"
      emptyActionSummary={EMPTY_ACTION_SUMMARY}
      onImport={(parsedMenu) =>
        dispatch(
          importMenuFromJson(businessUuid, currentBusiness.id, parsedMenu)
        )
      }
      onEmpty={() => dispatch(emptyPosMenu(businessUuid))}
      onExport={() => dispatch(exportPosMenu(currentBusiness.id))}
      exportFileType="pos-menu"
      businessName={currentBusiness?.companyName}
    />
  );
};

export default PosMenuImport;
